import graphicsUrl from "@/assets/select-your-repository-showcase-graphics.svg";

export const SelectRepositoryShowcase = () => {
    return (
        <div className="m-auto flex flex-col items-center p-8">
            <img
                src={graphicsUrl}
                alt="Graphics for increasing autonomy through security"
                className="h-64 select-none"
            />
            <p className="mb-2 mt-8 text-center text-2xl text-[rgb(var(--ona-gray-100))]">Sandboxed Ona environments</p>
            <p className="text-center text-[rgb(var(--ona-gray-100))]">
                Each Ona Agent executes within ephemeral Ona Environments with full OS-level isolation.
            </p>
        </div>
    );
};
